<template>
  <SelectDivisions :rank="selectedRank" />
</template>

<script>
import SelectDivisions from '@/components/registerFormSteps/SelectDivisions'

export default {
  name: 'Divisions',
  metaInfo: {
    title: `${process.env.VUE_APP_PAGE_TITLE} - Select Divisions`
  },
  components: {
    SelectDivisions
  },
  data () {
    return {
      //  Values
      selectedRank: this.$store.getters.rank
    }
  }
}
</script>
